<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M59 23.29V7a2 2 0 00-2-2H40.71a2 2 0 00-1.42.59l-33.5 33.5a2 2 0 000 2.82l16.3 16.3a2 2 0 002.82 0l6.41-6.4a14.46 14.46 0 0019.31.94l5.81 5.81a1.5 1.5 0 002.12 0 1.49 1.49 0 000-2.12l-5.81-5.81a14.46 14.46 0 00-.94-19.31l6.6-6.61a2 2 0 00.59-1.42zM41.5 53A11.5 11.5 0 1153 41.5 11.51 11.51 0 0141.5 53zM56 22.88l-6.52 6.52A14.49 14.49 0 0029.4 49.48l-5.9 5.9L8.62 40.5 41.12 8H56z"/><path d="M48.5 20a4.5 4.5 0 10-4.5-4.5 4.51 4.51 0 004.5 4.5zm0-6a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5z"/></svg>